import shareAlert from './shareAlert.vue';
import createInstance from '../index';

export default createInstance(shareAlert);
